<template>
  <!-- custom-form-common-area .cfca -->
  <div class="cfca">
    <div class="my-brand z-select">
      <div class="my-brand-l">{{fieldData.Value}}:</div>
      <div class="my-brand-r">
        <Poptip
          placement="bottom-start"
          width="232px"
          v-model="popVisible"
          @on-popper-show="showPop()"
        >
        <div style="padding-bottom: 20px;">
          <Button icon="ios-add" type="dashed">添加</Button> 

        </div>
          <div class="my-brand-add" slot="content">
            <div class="top">
              选择地区
              <span>（可多选）</span>
              <div class="top-choose" v-if="chooseTag">
                <template v-for="(item, index) in chooseTag">
                  <div
                    class="top-choose-item"
                    v-if="item.list.length"
                    :key="'choosetag' + index"
                    :class="{active: item.active}"
                    @click="setOtherParentActive(item.value)"
                  >{{item.value}}</div>
                </template>
              </div>
            </div>
            <div class="content">
              <template v-if="chooseTag && chooseTag.length">
                <div class="area-box" v-for="(subTag, index) in chooseTag" :key="'areatag' + index">
                  <div class="area-item" v-if="subTag.active">
                    <div class="area-item-l">
                      <p :class="{active: subTag.active}">{{subTag.value}}：</p>
                    </div>
                    <div class="area-item-r" v-if="subTag && subTag.list && subTag.list.length">
                      <div
                        class="air-box"
                        v-for="(t, idx) in subTag.list"
                        :key="'subTag' + idx"
                        :class="{active: t.active}"
                        @click="t.active = !t.active;setParentActive(subTag)"
                        :title="t.value"
                      >{{t.value}}</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="bottom">
              <span @click="popVisible=false">取消</span>
              <span class="plus" @click="handleAdd()">添加</span>
            </div>
          </div>
        </Poptip>
        <br /> 
        <template v-if="tag && tag.length">
          <div class="area-box" v-for="(subTag, index) in tag" :key="'areatag' + index">
            <div class="area-item">
              <div class="area-item-l">
                <p :class="{active: subTag.active}">
                  {{subTag.value}}
                  <span :style="{opacity: (subTag.list.length > 0 ? 1 : 0)}">:</span>
                </p>
              </div>
              <div class="area-item-r" v-if="subTag && subTag.list && subTag.list.length">
                <div
                  class="air-box"
                  v-for="(t, idx) in subTag.list"
                  :key="'subTag' + idx"
                  :class="{active: true}"
                  :title="t.value"
                >{{t.value}}</div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  // 领域类型 - 招募地区
  name: "custom-form-common-area",
  props: {
    field: {
      type: Object,
      default: { List: [], TypeId: 1, Value: "招募地区" }
    }
  },
  model: {
    prop: "field",
    event: "sendField"
  },
  data() {
    return {
      fieldData: { List: [], TypeId: 1, Value: "招募地区" },
      topTag: [], // 一级项目筛选
      tag: [],
      popVisible: false, // 显示选择tag
      chooseTag: [
        // 选择的tag列表
      ],
      // 0=授权渠道
      // 1=招募地区
      // 2=服务范围
      // 3=代工品类
      // 4=擅长领域
      // 5=合作渠道
      // 8=服务地区
      type: 1
    };
  },
  watch: {
    tag(val, oldVal) {
      // if (val && val.length) {
      // } else {
      //   this.fieldData.List = this.transfromData(this.tag);
      //   this.$emit("sendField", this.fieldData);
      //   this.$emit("refresh");
      // }
        this.fieldData.List = this.transfromData(this.tag);
        this.$emit("sendField", this.fieldData);
        this.$emit("refresh");
    }
  },
  async created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getActionTypeAndChild: "companyModule/getActionTypeAndChild"
    }),
    async init() {
      let data = await this.getActionTypeAndChild(this.type);
      const data2 = this.setActive(data);
      // data.map(c => (c.active = false));
      // data2.map((c, index) => {
      //   if (index === 0) {
      //     c.active = true;
      //   }
      // });
      this.chooseTag = data2;
      if (this.field && this.field.List) {
        let arr = [];
        if (this.chooseTag && this.chooseTag.length) {
          this.chooseTag.map(c => {
            this.field.List.forEach(v => {
              if (c.value === v.Value) {
                c.active = true; 
                let arr2 = JSON.parse(JSON.stringify(c));
                arr2.list = [];
                arr.push(arr2);
              }
              if (c.list && c.list.length) {
                c.list.map(z => {
                  if (z.value === v.Value) {
                    z.active = true;
                    if (z.list && z.list.length) {
                      z.list.map(b => {
                        b.active = true; 
                      });
                    }
                    arr.push(z);
                  }
                });
              }
            });
          });
        } 
        this.tag = arr;
      }
    },
    handleAdd() {
      let arr = JSON.parse(JSON.stringify(this.chooseTag));
      let filterArr = [];
      arr = arr.filter(c => c.active);
      arr.map(v => {
        if (v.list && v.list.length) {
          v.list = v.list.filter(v => v.active);
        }
        if (v.list.length > 0) {
          filterArr = filterArr.concat(v.list);
        } else {
          filterArr.push(v);
        }
      });
      console.log("filterArr", filterArr); 
      this.tag = filterArr;
      this.popVisible = false;
    },
    handleClose(index) {
      this.tag.splice(index, 1);
    },
    setTagActive(index) {
      this.chooseTag[index].active = true;
    },
    showPop() {
      this.tag.forEach(c => {
        this.chooseTag.map(v => {
          if (c.value === v.value) {
            v.active = true;
          }
        });
      });
    },
    setTopTag(data) {
      data.forEach(c => {
        if (c.list.length > 0) {
          this.topTag.push(c);
        }
      });
    },
    setActive(data) {
      data.map(c => {
        c.active = false;
        if (c.list.length) {
          c.list = this.setActive(c.list);
        }
      });
      return data;
    },
    setParentActive(data) {
      let len2 = 0;
      data.list.forEach(c => {
        if (c.active) {
          len2 += 1;
        }
      });
      this.chooseTag.map(c => {
        if (c.value === data.value && len2 > 0) {
          c.active = true;
        }
      });
    },
    setOtherParentActive(name) {
      this.chooseTag.map(c => {
        if (c.value === name) {
          c.active = !c.active;
          if (c.list.length > 0 && !c.active) {
            c.list.forEach(v => {
              v.active = false;
            });
          }
        }
      });
    },
    transfromData(data) {
      // 将数据转换成对应匹配的数据
      let arr = [];
      data.forEach(c => {
        let Arr = {
          TypeId: c.typeId,
          Value: c.value,
          List: []
        };
        let subArr = null;
        if (c.list.length) {
          let Arr = [];
          c.list.forEach(s => {
            Arr.push({
              TypeId: s.typeId,
              Value: s.value
            });
          });
          subArr = {
            TypeId: c.typeId,
            Value: c.value,
            List: Arr
          };
        } else {
          subArr = {
            TypeId: c.typeId,
            Value: c.value,
            List: c.List || []
          };
        }
        arr.push(subArr);
      });
      return arr;
    }
  }
};
</script>

<style lang="scss">
.my-brand {
  margin-bottom: 20px;
  &.z-select {
    .ivu-poptip-popper {
      height: 560px;
    }
    .my-brand-add {
      width: 368px;
      height: 560px;
      .content {
        width: 368px;
        height: 433px;
        padding: 20px;
      }
    }
  }
}
.area {
  &-box {
  }
  &-item {
    display: flex;
    &-l {
      color: #333;
      // width: 70px; 
      p {
        line-height: 32px;
      }
    }
    &-r {
      flex: 1;
      .air-box {
        width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #808080;
        padding: 5px 0;
        text-align: center;
        margin: 0 0 10px 10px;
        border-radius: 5px;
        border: solid 1px #7f7f7f;
        display: inline-block;
        float: left;
        line-height: initial;
        cursor: pointer;
        &:hover,
        &.active {
          border: solid 1px #178fff;
          color: #178fff;
        }
      }
    }
  }
}
.top-choose {
  overflow: hidden;
  &-item {
    width: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 5px 0;
    text-align: center;
    margin: 10px 10px 0 0;
    border-radius: 5px;
    display: inline-block;
    float: left;
    line-height: initial;
    border: solid 1px #7f7f7f;
    color: #808080;
    cursor: pointer;
    &:hover,
    &.active {
      border: solid 1px #178fff;
      color: #178fff;
    }
  }
}
</style>
